import React from 'react'
import { Link } from 'react-router'

export function Backlink({
	to = '/admin',
	label = 'Zurück zum Dashboard',
}: {
	to?: string
	label?: string
}) {
	return (
		<div className="mx-auto mt-2 mb-4 max-w-screen-2xl px-2 md:px-4">
			<Link to={to} className="hover:text-pcteal-700 text-xs hover:underline">
				&lt; {label}
			</Link>
		</div>
	)
}
